import axios from "axios";

export const client = axios.create({
  baseURL: `http://24grindbackend-env.eba-majbpxrk.us-east-1.elasticbeanstalk.com/`,
  withCredentials: true,
});

client.interceptors.request.use((request) => {
  const token = localStorage.getItem("token");
  if (token) {
    request.headers!.Authorization = token;
  }
  return request;
});
